module.exports = __webpack_public_path__ + "img/logo_icatu.7edf9d51.png";